<template>
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" :class="cls" :style="innerStyle" :stroke-width="strokeWidth" :stroke-linecap="strokeLinecap" :stroke-linejoin="strokeLinejoin" @click="onClick"><path fill-rule="evenodd" clip-rule="evenodd" d="m20.35 27.984.468 3.483h4.031l-1.78-12.8h-9.235l.68.633-5.18 12.167h3.82l1.57-3.483h5.625Zm-.211-2.171-.622-4.215h-1.935l-1.943 4.215h4.5Z" fill="currentColor" stroke="transparent"></path><path d="m27.922 18.666.68.86-1.57 11.94h4.265l2.039-12.8h-5.414Z" fill="currentColor" stroke="transparent"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M2.666 13.333A5.333 5.333 0 0 1 7.999 8h26.667a5.333 5.333 0 0 1 5.333 5.333v5.334l4.491-1.497A2.667 2.667 0 0 1 48 19.7v12.6a2.667 2.667 0 0 1-3.51 2.53L40 33.333v4a5.333 5.333 0 0 1-5.334 5.334H7.999a5.333 5.333 0 0 1-5.333-5.334v-24ZM7.999 12c-.736 0-1.333.597-1.333 1.333v24c0 .737.597 1.334 1.333 1.334h26.667c.736 0 1.333-.597 1.333-1.334v-24c0-.736-.597-1.333-1.333-1.333H7.999ZM40 22.883l4-1.333v8.9l-4-1.333v-6.234Z" fill="currentColor" stroke="transparent"></path></svg>
</template>

<script lang="ts">
import { defineComponent, computed, CSSProperties } from 'vue';
import { getPrefixCls } from '../../_utils/global-config';
import { isNumber } from '../../_utils/is';

export default defineComponent({
  name: 'IconBusinessAiInterviewOutline',
  props: {
    size: {
      type: [Number, String],
    },
    strokeWidth: {
      type: Number,
      default: 4
    },
    strokeLinecap: {
      type: String,
      default: 'butt',
      validator: (value: any) => {
        return ['butt', 'round', 'square'].includes(value);
      }
    },
    strokeLinejoin: {
      type: String,
      default: 'miter',
      validator: (value: any) => {
        return ['arcs', 'bevel', 'miter', 'miter-clip', 'round'].includes(value);
      }
    },
    rotate: Number,
    spin: Boolean
  },
  emits: {
    click: (ev: MouseEvent) => true,
  },
  setup(props, { emit }) {
    const prefixCls = getPrefixCls('icon');
    const cls = computed(() => [prefixCls, `${prefixCls}-business-ai-interview-outline`, { [`${prefixCls}-spin`]: props.spin }]);
    const innerStyle = computed(() => {
      const styles: CSSProperties = {};
      if (props.size) {
        styles.fontSize = isNumber(props.size) ? `${props.size}px` : props.size;
      }
      if (props.rotate) {
        styles.transform = `rotate(${props.rotate}deg)`;
      }
      return styles;
    });
    const onClick = (ev: MouseEvent) => {
      emit('click', ev);
    };

    return {
      cls,
      innerStyle,
      onClick,
    };
  }
});
</script>
